import { firebaseApp } from './firebase'
import 'firebase/firestore'

const fstore = firebaseApp.firestore()
fstore.settings({
    cacheSizeBytes: fstore.CACHE_SIZE_UNLIMITED
});
fstore.enablePersistence()
// firestore.settings({ timestampsInSnapshots: true })
export const firestore = fstore